<template>
    <v-dialog v-model="isShowDialog" max-width="800px" @click:outside="closePopup">
        <v-card>
            <v-card-title>
                <span class="title">{{ title }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap justify-end mb-1>
                    <v-btn color="green" @click="saveItem"><v-icon color="white">add</v-icon></v-btn>
                </v-layout>
                <v-layout row wrap>
                    <v-flex lg12>
                        <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                            :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                            :loading="loading" :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.id }}</td>
                                    <td> 
                                        <v-text-field v-model="item.made_in" label="Xuất xứ" single-line autofocus @change="saveItem(item)"></v-text-field>
                                    </td>
                                    <td class="text-center">
                                        <v-icon medium class="mr-2" @click="deleteItem(item.id)">delete</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1 white--text" @click="closePopup">Exit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import configs from "@/configs";
export default {
    name: "madein-popup",
    data() {
        return {
            viewName: "madein_list",
            isShowDialog: false,
            headers: [
                {
                    text: "ID",
                    value: "id",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Xuất xứ",
                    value: "made_in",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "",
                }
            ],
            pagination: { ...configs.PAGINATION, itemsPerPage: 10 },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE)
        };
    },
    props: ["dialogMadeIn", "title"],
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                this.filter_data();
            },
            deep: true,
        },
        dialogMadeIn() {
            this.isShowDialog = this.dialogMadeIn;
            if (this.dialogMadeIn) {
                this.filter_data();
            }
        }
    },
    computed: {
        ...mapState({
            items: (state) => state.madeins.all.data,
            total_rows: (state) => state.madeins.all.total,
            loading: (state) => state.madeins.loading,
            currentItem: (state) => state.madeins.selected
        })
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination
            };
            this.$store.dispatch("madeins/getList", param);
        },
        deleteItem: function (id) {
            this.$store.dispatch("madeins/removeDetail", id);
        },
        closePopup() {
            this.$emit("closePopup");
        },
        saveItem(item = {id: 0}) {
            this.$store.dispatch("madeins/setDetail", {data: item, id: item.id});
        },
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    },
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

ul {
    list-style: none
}

.remove {
    color: rgb(245, 8, 8)
}
</style>